import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  loading: boolean = false;

  private version = new BehaviorSubject('');
  version$ = this.version.asObservable();

  constructor() { }

  changeVersion(data: string) {
    this.version.next(data);
  }
}
